<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus" style="visibility: hidden;">+</span>
        <span v-else class="minus" style="visibility: hidden;">-</span>
        <span class="span-black pl-0">Proteine</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">9.17 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">1.3 g</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "proteine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
